import {
	PI2,
	revolutions,
	spinTime,
} from './constants';

const marginFromSegmentEdge = 0.05;

export const calculateCurrentAngle = (elapsedTime, totalAngle) => {
	const timeProgress = Math.min(1, elapsedTime / spinTime);
	const animationProgress = easeOutCubic(timeProgress);
	const nextAngle = (animationProgress * totalAngle) % PI2;

	return nextAngle;
};

export const generateTotalAngle = (winner, winnerAngle, segments) => {
	const finishAngle = winnerAngle || generateAngleForWinner(winner, segments);

	const totalAngle = revolutions * PI2 + finishAngle;

	return totalAngle;
};

const generateAngleForWinner = (winner, segments) => {
	const index = segments.map((s) => s.id).indexOf(winner);
	if (index >= 0) {
		const totalWeight = segments.reduce((sum, s) => sum + (s.weight || 1), 0);
		const cumulativeWeight = segments.slice(0, index).reduce((sum, s) => sum + (s.weight || 1), 0);
		const segmentWidth = PI2 * ((segments[index].weight || 1) / totalWeight);
		const finishAngle =
				PI2 -
				(PI2 * (cumulativeWeight / totalWeight) +
				segmentWidth * marginFromSegmentEdge +
				Math.random() * (segmentWidth - marginFromSegmentEdge * 2));

		return finishAngle;
	}

	return Math.random() * PI2;
};

function easeOutCubic(x) {
	// eslint-disable-next-line no-magic-numbers
	return 1 - Math.pow(1 - x, 3);
}
